import { useCookie } from './useCookie'

export const useCrsfToken = () => {
    const token = useCookie('csrftoken')
    return token
}
